module.exports = __webpack_public_path__ + "static/media/Xatu_gaussian2.398c020c.png";